module.exports = __webpack_public_path__ + "static/media/Pampalche_4.7c637dbd.jpg";